export const SET_START_POINT_COORDINATES = 'SET_START_POINT_COORDINATES';
export const SET_END_POINT_COORDINATES = 'SET_END_POINT_COORDINATES';
export const ADD_NEW_INTERMEDIATE_POINT = 'ADD_NEW_INTERMEDIATE_POINT';
export const CHANGE_INTERMEDIATE_POINT_COORDINATES =
  'CHANGE_INTERMEDIATE_POINT_COORDINATES';
export const REMOVE_INTERMEDIATE_POINT = 'REMOVE_INTERMEDIATE_POINT';
export const CLEAR_ROUTE_PLANNING_STATE = 'CLEAR_ROUTE_PLANNING_COORDINATES';
